import { MessagePaths, useMessagesTranslation } from '@shared/i18n';
import { DashboardResources } from '../types/DashboardResources';

export const useDashboardTranslation = () => useMessagesTranslation<DashboardResources>();

export type DashboardMessageKey = MessagePaths<DashboardResources>;

export const useDashboardTFunction = () => useDashboardTranslation().t;

export type DashboardTFunction = ReturnType<typeof useDashboardTFunction>;
